import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  testSection: {
    marginBottom: '25px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      borderColor: '#1976d2',
    },
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 20px',
    background: 'linear-gradient(135deg, #1e293b 0%, #334155 50%, #475569 100%)',
    color: 'white',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 8px rgba(30, 41, 59, 0.15)',
    '&:hover': {
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
      boxShadow: '0 4px 12px rgba(30, 41, 59, 0.25)',
    },
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    '& h3': {
      margin: 0,
      fontSize: '18px',
      fontWeight: 600,
      textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    },
  },
  toggleIcon: {
    fontSize: '14px',
    transition: 'transform 0.3s ease',
    fontWeight: 'bold',
    '&.expanded': {
      transform: 'rotate(90deg)',
    },
  },
  sectionProgress: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  progressBar: {
    width: '120px',
    height: '8px',
    backgroundColor: 'rgba(255,255,255,0.3)',
    borderRadius: '4px',
    overflow: 'hidden',
    position: 'relative',
  },
  progressFill: {
    height: '100%',
    background: 'linear-gradient(90deg, #4caf50 0%, #81c784 100%)',
    borderRadius: '4px',
    width: '0%',
    transition: 'width 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%)',
      animation: '$shimmer 2s infinite',
    },
  },
  '@keyframes shimmer': {
    '0%': { transform: 'translateX(-100%)' },
    '100%': { transform: 'translateX(100%)' },
  },
  progressText: {
    fontSize: '14px',
    fontWeight: 600,
    color: 'white',
    minWidth: '40px',
  },
  completionIcon: {
    fontSize: '18px',
    color: '#4caf50',
    fontWeight: 'bold',
    opacity: 0,
    transform: 'scale(0)',
    transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    '&.completed': {
      opacity: 1,
      transform: 'scale(1)',
      animation: '$bounce 0.6s ease',
    },
  },
  '@keyframes bounce': {
    '0%, 20%, 53%, 80%, 100%': { transform: 'scale(1)' },
    '40%, 43%': { transform: 'scale(1.2)' },
    '70%': { transform: 'scale(1.1)' },
  },
  sectionResetButton: {
    backgroundColor: '#ff9800',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
    transition: 'background-color 0.3s ease',
    marginLeft: '8px',
    '&:hover': {
      backgroundColor: '#f57c00',
    },
  },
  sectionContent: {
    maxHeight: 0,
    overflow: 'hidden',
    transition: 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
    position: 'relative',
    '&.expanded': {
      maxHeight: '2000000px',
      padding: '20px',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '2px',
        background: 'linear-gradient(90deg, #334155 0%, #475569 50%, #64748b 100%)',
      },
    },
  },
}));

const TestSection = ({
  sectionId,
  title,
  testCount,
  children
}) => {
  const classes = useStyles();

  return (
    <div className={classes.testSection} data-section={sectionId}>
      <div className={classes.sectionHeader} onClick={() => window.toggleSection(sectionId)}>
        <div className={classes.sectionTitle}>
          <span className={classes.toggleIcon} id={`${sectionId}-icon`}>▶</span>
          <h3>{title}</h3>
        </div>
        <div className={classes.sectionProgress}>
          <div className={classes.progressBar}>
            <div className={classes.progressFill} id={`${sectionId}-progress`}></div>
          </div>
          <span className={classes.progressText} id={`${sectionId}-text`}>0/{testCount}</span>
          <span className={classes.completionIcon} id={`${sectionId}-done`}>✓</span>
          <button
            onClick={(e) => {
              e.stopPropagation();
              window.resetSectionTests(sectionId);
            }}
            className={classes.sectionResetButton}
          >
            Reset
          </button>
        </div>
      </div>

      <div className={classes.sectionContent} id={`${sectionId}-content`}>
        {children}
      </div>
    </div>
  );
};

export default TestSection;
